import { Stack, Typography } from "@mui/material";
import { ExternalDocumentationCard } from "Components/Paypoints/ExternalIntegrations/ExternalDocumentationCard";
import { ExternalIntegrationCard } from "Components/Paypoints/ExternalIntegrations/ExternalIntegrationCard";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.ExternalIntegrations;

const INTEGRATIONS = [RESOURCES.WooCommerce, RESOURCES.PrestaShop];

export const ExternalIntegrationsSection = () => {
  const { t } = useResource();
  const apiUrl = getApiUrl();

  return (
    <Stack gap={1}>
      <Typography variant="h6">{t(RESOURCES.Title)}</Typography>
      <Typography variant="body2" color="text.secondary">
        {t(RESOURCES.Description)}
      </Typography>
      <Stack gap={2}>
        {INTEGRATIONS.map((integration) => (
          <ExternalIntegrationCard
            key={t(integration.Name)}
            name={t(integration.Name)}
            description={t(integration.Description)}
            pluginUrl={`${apiUrl}${t(integration.PluginUrl)}`}
            pluginLabel={t(RESOURCES.DownloadPlugin)}
            documentationUrl={`${apiUrl}${t(integration.DocumentationUrl)}`}
            documentationLabel={t(RESOURCES.DownloadDocumentation)}
          />
        ))}
        <ExternalDocumentationCard
          name={t(RESOURCES.PaymentGateway.Name)}
          description={t(RESOURCES.PaymentGateway.Description)}
          documentationUrl={`${apiUrl}${t(RESOURCES.PaymentGateway.DocumentationUrl)}`}
          documentationLabel={t(RESOURCES.DownloadDocumentation)}
        />
      </Stack>
    </Stack>
  );
};
